import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {modal} from 'react-redux-modal';
import validate from './validate';
import {renderField, renderDisabledField, renderCheckbox, renderSelect, renderHidden} from '../../../utils/renderFields';
import {saveUserProfile} from '../../../actions/currentUser';
import { UploadAvatarModal, EditLivecamOrder, ChangePasswordModal } from '../../';
import './styles.scss';
import DeleteAccount from '../../EditProfile/DeleteAccount';

const SORT_POPULAR = 1;
const SORT_DATE = 2;
const SORT_CUSTOM = 3;

const mapLiveCams = (items) => {
  return items.map((item, index) => {
    return {
      order: index,
      feed_id: item.id,
    };
  });
};

const propTypes = {
  closeForm: PropTypes.func,
  cancel: PropTypes.func,
  countries: PropTypes.array,
  websiteBackgrounds: PropTypes.array
};

const contextTypes = {
  router: PropTypes.object
};

const defaultProps = {
  websiteBackgrounds: [],
  initialValues: {},
  livecamsOrderOptions: [
    {value: SORT_POPULAR, label: 'Popular'},
    {value: SORT_DATE, label: 'Date Livecam Established'},
    {value: SORT_CUSTOM, label: 'Custom Sort Order'},
  ],
  cancel: _.noop
};

class EditProfileForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      liveCamCustomSort: false,
      livecamItems: []
    };
    this.submit = this.submit.bind(this);
    this.afterSubmit = this.afterSubmit.bind(this);
    this.toggleLivecamSortOrdering = this.toggleLivecamSortOrdering.bind(this);
    this.updateSortedItems = this.updateSortedItems.bind(this);
  }

  submit(values) {
    this.props.formStatus(false);
    return this.props.dispatch(saveUserProfile(values, this.props.closeForm, this.afterSubmit));
  }

  afterSubmit(response) {
    if (response.new_username) {
      this.context.router.push(`/members/${response.data.username}`);
    }
  }

  uploadImage() {
    modal.add(UploadAvatarModal, { title: '', size: 'medium', hideTitleBar: true });
  }

  changePassword() {
    modal.add(ChangePasswordModal, { title: '', size: 'medium', hideTitleBar: true });
  }

  componentWillMount() {
    const { initialValues, livecams } = this.props;
    const liveCamCustomSort = parseInt(initialValues.favorite_cam_sort) === SORT_CUSTOM;
    this.setState({ liveCamCustomSort, livecamItems:livecams });
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.avatarUri !== nextProps.avatarUri) {
      this.props.change('avatar_uri', nextProps.avatarUri);
    }
    if (this.state.livecamItems.map(i => i.id).join() !== nextState.livecamItems.map(i => i.id).join()) {
      this.props.change('fav_order', mapLiveCams(nextState.livecamItems));
    }
  }

  toggleLivecamSortOrdering(e) {
    const liveCamCustomSort = parseInt(e.target.value) === SORT_CUSTOM;
    this.setState({ liveCamCustomSort });
  }

  updateSortedItems(livecamItems) {
    this.setState({ livecamItems });
  }

  render() {
    const {
      handleSubmit,
      errors,
      error,
      reset,
      dirty,
      submitting,
      countries,
      websiteBackgrounds,
      submitSucceeded,
      avatarUri,
      username,
      cancel,
    } = this.props;
    const { liveCamCustomSort, livecamItems } = this.state;
    this.props.formStatus(dirty);

    const avatarUrl = (avatarUri) ? avatarUri : 'https://explore.org/images/icon_avatar_default.png';

    if (submitSucceeded) {
      this.props.formStatus(false);
      return (<div className="text-center" style={{ margin: '200px 0' }}>Profile successfully updated!</div>);
    }

    const consentHtml = (<span className="d-block mt-1">I consent to email analytics tracking</span>);

    return (
      <form className="edit-profile-form" onSubmit={handleSubmit(this.submit)}>
        <div className="form-inner-wrap">
          <span className={error ? 'has-danger' : ''}>
              <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>
          <div className="row align-items-center">
            <div className="col-sm-6">
              <div className="avatar" style={{ backgroundImage: `url("${avatarUrl}")` }} onClick={this.uploadImage}/>
              <Field name="avatar_uri" component={renderHidden} type="hidden" className="form-control"/>
            </div>
            <div className="col-sm-6">
              <div className="row align-items-center">
                <div className="col-sm-12">
                  <div className="btn btn-secondary" onClick={this.uploadImage}>Change Profile Image</div>
                  <div className="pt-10 text-center">Profile Image Size <br/> 160 x 160</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h5 className="mt-2">Your Info</h5>
            <hr className="border-top mt-2 mb-3"/>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Field name="first_name" className="form-control" type="input" component={renderField}
                     label="First Name"/>
            </div>
            <div className="col-sm-6">
              <Field name="last_name" className="form-control" type="input" component={renderField}
                     label="Last Name"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Field name="username" className="form-control" type="input" component={renderDisabledField}
                     label="Username"/>
            </div>
            <div className="col-sm-6">
              <Field name="display_name" className="form-control" type="input" component={renderField}
                     label="Explore Display Name"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Field name="email" type="email" component={renderField} groupClass="row" className="form-control"
                     label="Email"/>
            </div>
            <div className="col-sm-6">
              <Field name="dob" type="text" component={renderField} groupClass="row" className="form-control"
                     label="Birthday" placeholder="MM/DD/YYY"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Field name="newsletter" component={renderCheckbox} className="form-check-input"
                     label="Subscribe to newsletter"/>
              <Field name="tracking_consent" component={renderCheckbox} className="form-check-input"
                     labelHTML={consentHtml} labelClassName="u-textSize-12"/>
            </div>
            <div className="col-sm-6">
              <div className="btn btn-secondary" onClick={this.changePassword}>Change Password</div>
              <DeleteAccount />
            </div>
          </div>
          <div>
            <h5 className="mt-4">Your Explore Experience</h5>
            <hr className="border-top mt-2 mb-3"/>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Field name="background_type" options={websiteBackgrounds} component={renderSelect}
                     noPlaceholder
                     className="form-control" label="Website Background"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Field
                name="favorite_cam_sort"
                options={this.props.livecamsOrderOptions}
                component={renderSelect}
                noPlaceholder
                className="form-control"
                label="Livecams Favorite Sort Order"
                onChange={this.toggleLivecamSortOrdering}
              />
            </div>
          </div>
        </div>
        {liveCamCustomSort && <div className="livecams-order-wrap">
          <div className="livecams-order-title text-center">Click and Drag to Change Livecam Sort Order</div>
          <EditLivecamOrder livecams={livecamItems} updatedSortedItems={this.updateSortedItems}/>
        </div>
        }
        <div className="bg-fff p-20 mt-60">
          <div className="form-inner-wrap">
            <div className="row buttons-row">
              <div className="col-sm-6">
                <button type="button" disabled={submitting} onClick={cancel} className="btn btn-cancel">Cancel</button>
              </div>
              <div className="col-sm-6">
                <button type="submit" disabled={submitting} className="btn btn-primary">Save</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { backgroundChoice } = state.uiPreferences;
  const {data:userData} = state.currentUser;
  const livecams = _.get(state.memberProfile.data, 'favorites.livecams', []);
  let initialValues = {};
  if (userData) {
    initialValues = {
      avatar_uri: userData.avatar_uri,
      background_type: backgroundChoice,
      first_name: userData.first_name,
      last_name: userData.last_name,
      username: userData.username,
      display_name: userData.display_name,
      country_id: userData.country,
      email: userData.email,
      dob: userData.dob,
      favorite_cam_sort: userData.favorite_cam_sort,
      newsletter: userData.newsletter,
      tracking_consent: userData.tracking_consent,
      fav_order: mapLiveCams(livecams),
    };
  }
  return {
    initialValues,
    websiteBackgrounds: state.globalConfig.website_backgrounds,
    closeForm: ownProps.closeForm,
    submitted: state.currentUser.editedSuccessfully,
    avatarUri: _.get(state.currentUser, 'data.avatar_uri', null),
    username: _.get(state.currentUser, 'data.username', null),
    formStatus: ownProps.formStatus,
    cancel: ownProps.cancel,
    livecams: _.get(state.memberProfile.data, 'favorites.livecams', []),
  }
};

EditProfileForm = reduxForm({
  form: 'edit-profile',
  validate,
  fields: ['username', 'country', 'email', 'background'],
  onSubmitFail: (e) => {
    window.scroll(0, 0);
  },
  onSubmitSuccess:(e) => {
    window.scroll(0, 0);
  }
})(EditProfileForm);

EditProfileForm.propTypes = propTypes;
EditProfileForm.contextTypes = contextTypes;
EditProfileForm.defaultProps = defaultProps;

export default connect(mapStateToProps)(EditProfileForm);
